<script setup lang="ts">
defineProps<{ title: string }>()
</script>

<template>
  <div class="flex flex-col gap-3xs">
    <dt class="text-base" v-text="title" />
    <dd class="font-heading text-2xl font-light">
      <slot />
    </dd>
  </div>
</template>
